import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { resolveCollectionSummaryState, toCollectionSummaryData, } from "./collectionSummary.rules";
var REQUEST_KEY = "cobranzaBillingBatchSummary";
export var useGetCollectionSummary = function (collectionId) {
    var dispatch = useDispatch();
    var data = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var error = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    useEffect(function () {
        dispatch(clearCustomRequest(REQUEST_KEY));
        if (!collectionId)
            return;
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "GET",
            path: "/billing/Api/V1/BillingBatchSummary",
            queryParams: {
                billingCollectionJobId: collectionId,
                page: 1,
                limit: 50,
            },
        }));
    }, [collectionId]);
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    var summary = useMemo(function () {
        return resolveCollectionSummaryState({
            collectionId: collectionId,
            error: error,
            data: toCollectionSummaryData((Array.isArray(data) ? data : []).filter(function (row) { return row.billingCollectionJobId === collectionId; })),
        });
    }, [collectionId, error, data]);
    return { summary: summary, error: error };
};
